import styled from 'styled-components'

export const Wrapper = styled.div`
  > span {
    transition: 200ms;
    color: #0085ff;
    font-weight: bold;
    cursor: pointer;
    svg {
      margin-left: 5px;
    }
    &:hover {
      opacity: 0.7;
    }
  }
`
